import { z } from "zod";
import { recordId } from "./contracts";
import { paymentRecipientKind } from "./payment-dues";

export const AUTOPAY_CONSENT_VERSION = "autopay-recipient-v1";

export const autopayQuery = z.object({ actingOrganization: recordId.toLowerCase() });
export type AutopayQuery = z.infer<typeof autopayQuery>;

export const autopayRequest = z.object({ actingOrganization: recordId.toLowerCase() }).strict();
export type AutopayRequest = z.infer<typeof autopayRequest>;

export const autopayEnableRequest = autopayRequest
  .extend({
    consentAccepted: z.literal(true, { message: "Accept the autopay authorization before turning autopay on." }),
    consentVersion: z.literal(AUTOPAY_CONSENT_VERSION, { message: "Reload the page to accept the current autopay authorization." }),
  })
  .strict();
export type AutopayEnableRequest = z.infer<typeof autopayEnableRequest>;

export const autopayRunStatus = z.enum(["succeeded", "failed", "skipped"]);
export type AutopayRunStatus = z.infer<typeof autopayRunStatus>;

export const autopayEnrollment = z.object({
  recipient: z.object({ kind: paymentRecipientKind, id: recordId }),
  enabled: z.boolean(),
  paused: z.boolean(),
  pauseReason: z.string().nullable(),
  lastRunAt: z.string().nullable(),
  lastRunStatus: autopayRunStatus.nullable(),
  lastRunError: z.string().nullable(),
  lastRunAmountCents: z.number().int().nullable(),
});
export type AutopayEnrollment = z.infer<typeof autopayEnrollment>;

export const autopayEnrollmentList = z.object({ items: z.array(autopayEnrollment) });
export type AutopayEnrollmentList = z.infer<typeof autopayEnrollmentList>;

export const autopayPreview = z.object({
  amountCents: z.number().int(),
  currency: z.string(),
  itemCount: z.number().int().nonnegative(),
  termsDays: z.number().int(),
  timezone: z.string(),
  completedBefore: z.string(),
});
export type AutopayPreview = z.infer<typeof autopayPreview>;
